export const CONTENT_TYPES = {
  faqSection: 'faqSection',
  faqCategory: 'faqCategory',
  homeownerFaqs: 'homeownerFaqs',
  faqQuestionsAndAnswers: 'faqQuestionsAndAnswers',
  homeownerFaqQuestionsAndAnswers: 'homeownerFaqQuestionsAndAnswers',
  staticPage: 'staticPage',
  valueProp: 'valueProp',
  valuePropItem: 'valuePropItem',
  serviceFeeDetails: 'serviceFeeDetails',
  seoContentBlock: 'seoContentBlock',
  jsonBlob: 'jsonBlob',
}
